const AppTypes = {
    LAFIA: 'lafia',
    NSUK: 'nsuk',
    FPN: 'fpn',
    CURRENT: 'nsuk',
};

module.exports = AppTypes
